<template>

<app-wrapper>

    <app-inner :row="true" class="advverts">

        <a :href="advert.url" class="advverts-item" v-for="(advert, index) in page.adverts" :key="index" :style="{backgroundImage: 'url(' + advert.image + ')'}">

            <div class="advverts-item-text">{{ advert.name }}</div>

        </a>

    </app-inner>

</app-wrapper>

</template>

<script>

export default {

}

</script>

<style scoped>

.advverts {
    flex-wrap: wrap;
}

.is-mobile .advberts {
    flex-direction: column;
}

.advverts-item {
    display: block;
    border-radius: 4px;
    background-position: 50% 50%;
    background-size: cover;
    margin: 5px;
    width: calc(33.3% - 10px);
    height: 365px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;
    transition: all 100ms linear;
}

.is-tablet .advverts-item {
    height: 250px;
}

.is-mobile .advverts-item {
    height: 160px;
}

.is-desktop .advverts-item:hover {
    transform: scale(1.01);
}

.advverts-item:nth-child(1),
.advverts-item:nth-child(2) {
    width: calc(50% - 10px);
}

.is-mobile .advverts-item {
    width: 100%;
}

.is-mobile .advverts-item:nth-child(1),
.is-mobile .advverts-item:nth-child(2) {
    height: 240px;
}

.advverts-item-text {
    padding: 20px;
    color: #fff;
    background: linear-gradient(180deg,transparent 0,rgba(0,0,0,.65));
    font-family: grueber,serif;
    font-size: 32px;
}

.is-tablet .advverts-item-text {
    padding: 10px;
    font-size: 20px;
}

.is-mobile .advverts-item-text {
    padding: 10px;
    font-size: 20px;
}

</style>
